import { Alert, Loader, PaymentFooter, Toast } from "get-life-storybook-ts";
import LayoutController from "./Layout.controller";
import WeCallYou from "../../components/WeCallYou/WeCallYou";
import BannerEnvironment from "../../components/BannerEnvironment/BannerEnvironment";
import V3Nav from "../../components/V3Nav/V3Nav";
import { DOMAIN, ENV } from "../../constants/Global";
import { useLocation } from "react-router";
import { GlobalShowTruspilot } from "../../utils/InternationlChanges";
import { LanguageT } from "../../context/GetLifeContext.context";
import { pageHasOwnShell } from "../../utils/dashboardShell";

const Layout = ({ children }: any) => {
  const {
    loading,
    multiCountries,
    nodeElementAlert,
    notification,
    showFooter,
    showHeader,
    translate,
    toast,
    toastIsOpen,
    logo: configLogo,
  } = LayoutController();

  const location = useLocation();

  const {
    phone,
    handleCall,
    logo,
    logoSize,
    secondaryLogo,
    logoClassname,
    secondaryLogoClassname,
  } = multiCountries();

  const isDashboard = location.pathname.includes("/dashboard");
  // Pantallas native con marco propio (Dashboard, presupuesto): traen su barra y
  // su pie, sin duplicar logo ni franjas blancas.
  const chromeless = pageHasOwnShell(location.pathname, location.search);
  const operationsPhoneFR = "01 87 21 05 43";

  let phoneNumber = phone;
  if (DOMAIN === "fr" && isDashboard) phoneNumber = operationsPhoneFR;

  return (
    <>
      {process.env.REACT_APP_ENVIROMENT !== "PRD" && (
        <BannerEnvironment environment={ENV} locale={DOMAIN} />
      )}

      <WeCallYou />

      {notification && (
        <Alert
          buttonAlertConfig={notification.buttonAlertConfig}
          close={notification.close}
          color={notification.color}
          iconName={notification.iconName}
          message={notification.message}
          positionX={notification.positionX}
          positionY={notification.positionY}
          ref={nodeElementAlert}
          time={notification.time}
          type={notification.type}
        />
      )}
      {showHeader && !chromeless && (
        <V3Nav
          logo={logo}
          logoSize={logoSize}
          logoClassname={logoClassname}
          secondaryLogo={secondaryLogo}
          secondaryLogoClassname={secondaryLogoClassname}
          configLogo={configLogo}
          useConfigLogo={!!(configLogo && DOMAIN === "sql_es")}
          phone={phoneNumber}
          onPhoneClick={handleCall}
        />
      )}
      <Toast
        open={toastIsOpen}
        offset={{
          top: "80px",
        }}
        {...toast}
      />

      <div className="layout">
        {loading && (
          <div className="h-loader">
            <Loader loading={loading} />
          </div>
        )}
        {children}
      </div>
      {showFooter && !chromeless && <PaymentFooter text={translate("paymentFooter.text")} showTrustPilot={GlobalShowTruspilot[DOMAIN as LanguageT]}/>}
    </>
  );
};

export default Layout;
